module.exports = __webpack_public_path__ + "assets/img/del.3db4f393.svg";